export default "__VITE_ASSET__ae4a24ba__"